module.exports = __webpack_public_path__ + "img/logo.b07448d3.png";